__turbopack_context__.v({
  "active": "MobileNav-module-scss-module__lkflYG__active",
  "badge": "MobileNav-module-scss-module__lkflYG__badge",
  "iconWrap": "MobileNav-module-scss-module__lkflYG__iconWrap",
  "item": "MobileNav-module-scss-module__lkflYG__item",
  "label": "MobileNav-module-scss-module__lkflYG__label",
  "nav": "MobileNav-module-scss-module__lkflYG__nav",
});
